export default __webpack_public_path__ + "static/media/guide_strips@3x.be7656b8.png";